import React from 'react'

function ProductSke() {
    return (
        <div className='w-full'>
            {/* image*/}
            <div className="relative pt-[111%] rounded-xl">
                <div
                    className="w-full h-full absolute top-0 left-0 right-0 
                    bottom-0 bg-gray-100 animate-pulse">
                </div>
            </div>

            <div className="space-y-2 mt-2">
                <div className="h-4 bg-gray-100 rounded-full animate-pulse"></div>
                <div className="h-3 bg-gray-100 rounded-full w-32 animate-pulse"></div>
            </div>
        </div>
    )
}

export default ProductSke